import { Image } from '@belong/ui';
import clsx from 'clsx';
import { RichTextSlice } from 'src/features/blog/components/rich-text-slice/rich-text-slice';
import css from './blockquote.module.css';

export function Blockquote({ primary }: any) {
  return (
    <div className="md:pl-2xl pl-0">
      <div className="md:pl-xl relative pl-0">
        <Image
          src="/icons/quotes.svg"
          alt=""
          className={clsx(css.image, 'relative left-0 top-0 md:absolute')}
        />
        <div className="pt-2sm">
          <RichTextSlice primary={primary} />
        </div>
      </div>
    </div>
  );
}
